import { createFileRoute } from '@tanstack/react-router'

import { DigitalProductMission } from '@/features/missions/Show'

export const Route = createFileRoute('/_event/missoes/$missionId/')({
  component: DigitalProductMissionPage
})

function DigitalProductMissionPage() {
  const { missionId } = Route.useParams()

  return <DigitalProductMission id={missionId} />
}
